import styled from 'styled-components';
import colors from 'Styles/colors';

export const Label = styled.div`
  font-size: 12.5px;
  font-weight: normal;
  letter-spacing: 0.09px;
  color: ${colors.grey17};
  padding-bottom: 5px;
  padding-right: 15px;
`;
Label.displayName = 'Label';

export const Field = styled.input`
  padding: 9px 53px 8px 15px;
  box-shadow: inset 0 -1px 0 0 ${(props) => (props.failed ? 'red' : '#afafaf')};
  background-color: ${colors.iceBlue};
  height: 34px;
  border: 0;
`;
Field.displayName = 'Field';

export const FieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 50%;
  padding: 0px 8px 0 0;
  padding-bottom: 21px;
  &[required] {
    ${Label}::after {
      content: ' *';
      color: ${colors.redPink};
    }
  }
`;
FieldWrapper.displayName = 'FieldWrapper';

export const FieldMessage = styled.div`
  font-size: 11.5px;
  font-weight: normal;
  color: ${colors.grey5};
`;
